module.exports = __webpack_public_path__ + "storm_handing-342913755c63ff8a78865a93843b1d26.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/storm_handing.png
// module id = ZdED
// module chunks = client